import types from './types';
import { getErrorMessage } from '../../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_INVENTORY_HISTORY_FAILURE:
      return {
        title: t('message.title.error.get.inventory.history'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_INITIAL_DATA_FAILURE:
      return {
        title: t('message.title.error.get.inventory.initial.data'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
